import { Outlet } from "react-router-dom";
import Navigationbar from "./UserManagement/NavigationBar";
import './MainLayout.css';

const MainLayout = ({ mode, toggleTheme }) => {
  return (
    <>
      <div className="app-layout">
        <div className="navbar-wrapper">
          <Navigationbar mode={mode} toggleTheme={toggleTheme} />
        </div>

        <div className="page-content">
          <Outlet />
        </div>
      </div>
    </>
  )
}
export default MainLayout;